"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parse3do = void 0;
const ByteUtils = __importStar(require("./byte-utils"));
const structs_1 = require("./structs");
function fromBuffer(data) {
    return {
        rootNodes: parseObjects(data, 0),
    };
}
function parseObjects(data, offset) {
    const result = [];
    let nextSibling = offset;
    do {
        const struct = ByteUtils.makeStruct(data, nextSibling, structs_1.OBJECT_STRUCT);
        // debugPrintStruct(struct);
        const name = parseName(data, struct['OffsetToObjectName']);
        const vertices = parseVertices(data, struct['OffsetToVertexArray'], struct['NumberOfVertexes']);
        const primitives = parsePrimitives(data, struct['OffsetToPrimitiveArray'], struct['NumberOfPrimitives']);
        const children = struct['OffsetToChildObject'] !== 0
            ? parseObjects(data, struct['OffsetToChildObject'])
            : [];
        const object = {
            name,
            vertices,
            primitives,
            children,
            xOffset: struct['XFromParent'],
            yOffset: struct['YFromParent'],
            zOffset: struct['ZFromParent'],
        };
        result.push(object);
        nextSibling = struct['OffsetToSiblingObject'];
    } while (nextSibling !== 0);
    return result;
}
const textDecoder = new TextDecoder('ascii');
const NAME_LIMIT = 256;
function parseName(data, offset) {
    let size = 0;
    for (let i = 0; i < NAME_LIMIT; i++) {
        size = i;
        const nextByte = data.getUint8(offset + i);
        if (nextByte === 0)
            break;
    }
    /*if (size === 0) {
      return '';
    }*/
    const slice = new Uint8Array(data.buffer, offset, size);
    return textDecoder.decode(slice);
}
function parseVertices(data, offset, count) {
    const result = [];
    for (let i = 0; i < count; i++) {
        const struct = ByteUtils.makeStruct(data, offset + (i * structs_1.VERTEX_STRUCT_SIZE), structs_1.VERTEX_STRUCT);
        result.push({
            x: struct.x,
            y: struct.y,
            z: struct.z,
        });
    }
    return result;
}
function parsePrimitives(data, offset, count) {
    const result = [];
    for (let i = 0; i < count; i++) {
        const struct = ByteUtils.makeStruct(data, offset + (i * structs_1.PRIMITIVE_STRUCT_SIZE), structs_1.PRIMITIVE_STRUCT);
        const vertexIndices = [];
        for (let v = 0; v < struct['NumberOfVertexIndexes']; v++) {
            // v * 2 because each vertex index reads 2 bytes (aka Uint16)
            const nextVertexIndex = data.getUint16(struct['OffsetToVertexIndexArray'] + (v * 2), true);
            vertexIndices.push(nextVertexIndex);
        }
        const textureName = parseName(data, struct['OffsetToTextureName']);
        result.push({
            vertexIndices,
            textureName,
        });
    }
    return result;
}
function debugPrintStruct(struct) {
    for (const [field, value] of Object.entries(struct)) {
        const hex = '0x' + value.toString(16).toUpperCase().padStart(4, '0');
        console.log(`${field}: ${value} (${hex})`);
    }
    console.log();
}
exports.Parse3do = {
    fromBuffer,
};
